export const GUIDED_COACHING_FLAG_NAMES = Object.freeze({
  releasedExperience: 'REACT_APP_GUIDED_COACHING_ENABLED',
  legacyPlanner: 'REACT_APP_GUIDED_COACHING_LEGACY_PLANNER_ENABLED',
  adaptivePlanner: 'REACT_APP_GUIDED_COACHING_ADAPTIVE_PLANNER_ENABLED',
  adaptiveDifficultDecision: 'REACT_APP_GUIDED_COACHING_ADAPTIVE_DIFFICULT_DECISION_ENABLED',
  liveCanvas: 'REACT_APP_GUIDED_COACHING_LIVE_CANVAS_ENABLED',
  expandedSelector: 'REACT_APP_GUIDED_COACHING_EXPANDED_SELECTOR_ENABLED',
  situationMatcher: 'REACT_APP_GUIDED_COACHING_SITUATION_MATCHER_ENABLED'
});

export const GUIDED_COACHING_CORE_WORKFLOW_IDS = Object.freeze([
  'clarity-when-overwhelmed',
  'difficult-decision'
]);

export const GUIDED_COACHING_WORKFLOW_FLAG_NAMES = Object.freeze({
  'career-crossroads': 'REACT_APP_GUIDED_COACHING_WORKFLOW_CAREER_CROSSROADS_ENABLED',
  'prepare-difficult-conversation': 'REACT_APP_GUIDED_COACHING_WORKFLOW_DIFFICULT_CONVERSATION_ENABLED',
  'sustainable-pace-energy': 'REACT_APP_GUIDED_COACHING_WORKFLOW_SUSTAINABLE_PACE_ENABLED',
  'weekly-life-reset': 'REACT_APP_GUIDED_COACHING_WORKFLOW_WEEKLY_RESET_ENABLED',
  'life-meaning-spirituality': 'REACT_APP_GUIDED_COACHING_WORKFLOW_MEANING_ENABLED',
  'life-transition-next-chapter': 'REACT_APP_GUIDED_COACHING_WORKFLOW_TRANSITION_ENABLED',
  'relationship-patterns-needs': 'REACT_APP_GUIDED_COACHING_WORKFLOW_RELATIONSHIPS_ENABLED',
  'boundaries-without-guilt': 'REACT_APP_GUIDED_COACHING_WORKFLOW_BOUNDARIES_ENABLED',
  'confidence-after-setback': 'REACT_APP_GUIDED_COACHING_WORKFLOW_SETBACK_ENABLED',
  'custom-guided-session': 'REACT_APP_GUIDED_COACHING_WORKFLOW_CUSTOM_ENABLED'
});

const enabled = (env, name, defaultValue = false) => {
  const value = env?.[name];
  if (value === undefined || value === null || value === '') return defaultValue;
  return String(value).trim().toLowerCase() === 'true';
};

export const resolveGuidedCoachingFeatureFlags = (env = process.env) => {
  const legacyPlannerRequested = enabled(env, GUIDED_COACHING_FLAG_NAMES.legacyPlanner, true);
  const adaptivePlanner = enabled(env, GUIDED_COACHING_FLAG_NAMES.adaptivePlanner, false);
  const legacyPlanner = legacyPlannerRequested || !adaptivePlanner;
  const expandedSelector = enabled(env, GUIDED_COACHING_FLAG_NAMES.expandedSelector, false);
  const workflows = Object.freeze(Object.fromEntries(
    Object.entries(GUIDED_COACHING_WORKFLOW_FLAG_NAMES)
      .map(([workflowId, flagName]) => [workflowId, enabled(env, flagName, false)])
  ));

  return Object.freeze({
    releasedExperience: enabled(env, GUIDED_COACHING_FLAG_NAMES.releasedExperience, false),
    legacyPlanner,
    adaptivePlanner,
    adaptiveDifficultDecision: adaptivePlanner && enabled(env, GUIDED_COACHING_FLAG_NAMES.adaptiveDifficultDecision, false),
    liveCanvas: enabled(env, GUIDED_COACHING_FLAG_NAMES.liveCanvas, false),
    expandedSelector,
    situationMatcher: expandedSelector && enabled(env, GUIDED_COACHING_FLAG_NAMES.situationMatcher, false),
    workflows
  });
};

export const getGuidedCoachingPlannerMode = ({
  flags = resolveGuidedCoachingFeatureFlags(),
  adaptivePlannerAvailable = false
} = {}) => (
  flags.adaptivePlanner && adaptivePlannerAvailable ? 'adaptive' : 'legacy'
);

export const listVisibleGuidedWorkflowIds = (flags = resolveGuidedCoachingFeatureFlags()) => Object.freeze([
  ...GUIDED_COACHING_CORE_WORKFLOW_IDS,
  ...(flags.expandedSelector
    ? Object.keys(GUIDED_COACHING_WORKFLOW_FLAG_NAMES).filter((workflowId) => flags.workflows[workflowId] === true)
    : [])
]);

export const isLocalGuidedCoachingDesignReview = ({ nodeEnv, pathname, hostname }) => (
  nodeEnv === 'development'
  && pathname === '/guided-coaching-design-review'
  && ['localhost', '127.0.0.1', '::1'].includes(hostname)
);

export default resolveGuidedCoachingFeatureFlags;
